<div class="w-100 row mt-3">
  <app-dashboard-filters
    class="col-12"
    [solution]="selectedSolution"
    (changeSolution)="changeSolution($event)"
    [dateRange]="{ start: start, end: end }"
    (changeDate)="changeDate($event)"
    (changeUnit)="changeUnit($event)"
  ></app-dashboard-filters>

  @if (rights?.includes('SummaryWidgets')) {
    <div class="col-8">
      <app-summary-charts
        [solutionId]="selectedSolution"
        [start]="start"
        [end]="end"
        [selectedUnit]="selectedUnit"
      ></app-summary-charts>
    </div>
    <div class="col-4">
      <app-cases-by-scoreclass
        [solutionId]="selectedSolution"
        [start]="start"
        [end]="end"
        [selectedUnit]="selectedUnit"
      ></app-cases-by-scoreclass>
    </div>
    <app-top-5-summary
      class="col-12 my-3"
      [showClassesChanged]="true"
      [solutionId]="selectedSolution"
      [start]="start"
      [end]="end"
      [selectedUnit]="selectedUnit"
    ></app-top-5-summary>
  }
  @if (rights?.includes('CaseStatsWidget')) {
    <app-case-stats
      class="col-12"
      [solutionId]="selectedSolution"
      [start]="start"
      [end]="end"
      [selectedUnit]="selectedUnit"
    ></app-case-stats>
  }
</div>
